enum TriageType {
  WG = 1,
  WN = 2,
}

export default TriageType;
